/**
 * 回収日
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifests`

 const manifest_maintenance_collect = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/collects`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit }, { id, params }) {
      const api_path = `${API_PATH}/${id}/collects`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(data.content)
        } )
      })
    },

  },
  mutations: {},

 }

 export default manifest_maintenance_collect
